import React, { useState } from "react";
import {
    Button,
    Modal,
    Form,
    Input,
    Space,
    Row,
    Col,
    Select,
    useSelect,
    useModalForm,
} from "@pankod/refine-antd";
import { Typography } from 'antd';

const { Text } = Typography;

export const CreateTransBnkCbModal: React.FC<{ refetchTableProps: any; companyDetail: any; transBnkListingOptions: any }> = (
    {
        refetchTableProps,
        companyDetail,
        transBnkListingOptions
    }) => {
    const title = "TransBnk Connected Banking"
    const companyId = companyDetail.id;
    const brandName = companyDetail.brandName;

    const [serviceProviderId, setServiceProviderId] = useState<string | null>(null);
    const [bankAccountValidationRequestId, setBankAccountValidationRequestId] = useState<string | null>(null);

    const { selectProps: subMerchantBusinessTypeOptions } = useSelect<any>({
        dataProviderName: "grapghQl",
        resource: 'getSubMerchantBusinessTypesForTransBnk',
        optionLabel: "description",
        optionValue: "id",
        debounce: 500,
    });

    const { selectProps: subMerchantEntityTypeOptions } = useSelect<any>({
        dataProviderName: "grapghQl",
        resource: 'getSubMerchantEntityTypesForTransBnk',
        optionLabel: "description",
        optionValue: "id",
    });

    let {
        modalProps: connectedBankingDetailsModal,
        formProps: connectedBankingDetailsForm,
        show: connectedBankingDetailsShow,
        close: connectedBankingDetailsClose,
    } = useModalForm<any>({
        action: "create",
        dataProviderName: "grapghQl",
        resource: `verifyConnectedBankingBankAccountDetails`,
        metaData: {
            companyId
        },
        redirect: false,
        onMutationSuccess({data}) {
            setBankAccountValidationRequestId(data.bankAccountValidationRequestId);
            setServiceProviderId(data.serviceProviderId);
            connectedBankingDetailsClose();
            initiateCorporateOnboardingModalShow();
        }
    });
    connectedBankingDetailsModal.title = title;
    connectedBankingDetailsModal.centered = true;
    connectedBankingDetailsModal.width = 800;
    
    let {
        modalProps: initiateCorporateOnboardingModal,
        formProps: initiateCorporateOnboardingForm,
        show: initiateCorporateOnboardingModalShow,
        close: initiateCorporateOnboardingModalClose,
    } = useModalForm<any>({
        action: "create",
        dataProviderName: "grapghQl",
        resource: `initiateCorporateOnboardingRequestForTransBnkConnectedBanking`,
        metaData: {
            companyId,
            brandName,
            serviceProviderId,
            bankAccountValidationRequestId,
        },
        redirect: false,
        onMutationSuccess() {
            initiateCorporateOnboardingModalClose();
            refetchTableProps(true)
        }
    });
    initiateCorporateOnboardingModal.title = title;
    initiateCorporateOnboardingModal.centered = true;
    initiateCorporateOnboardingModal.width = 800;

    const handleConnectedBankingDetailsClose =() => {
        connectedBankingDetailsForm.form?.resetFields();
        initiateCorporateOnboardingForm.form?.resetFields();
        connectedBankingDetailsClose();
    }
    return (
        <Space>
            <Button onClick={() => connectedBankingDetailsShow()}>
                TransBnk CB
            </Button>

            <Modal
                {...connectedBankingDetailsModal}
                closable={false}
                maskClosable={false}
                keyboard={false}
                footer={[
                    <Button
                        key="back"
                        onClick={handleConnectedBankingDetailsClose}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        onClick={() => {
                            connectedBankingDetailsForm.form?.submit();
                        }}>
                        Next
                    </Button>,
                ]}
            >
                <Form
                    {...connectedBankingDetailsForm}
                    layout="vertical"
                    initialValues={{
                        companyId,
                        accountNameForValidation: brandName,
                    }}
                >
                    <Row align="middle" gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label="Service Provider Integration"
                                name="bankIntegratorId"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please select a value",
                                    },
                                ]}
                            >
                                <Select
                                    options={transBnkListingOptions}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="accountNumber"
                                label="Account Number"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter the account number",
                                    },
                                ]}
                            >
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="ifsc"
                                label="IFSC Code"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter the IFSC code"
                                    }]
                                }
                            >
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="accountNameForValidation"
                                label="Brand Name"
                            >
                                <Input
                                    value={brandName}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="mobileNumber"
                                label="Mobile Number"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter the mobile number",
                                    },
                                ]}
                            >
                                <Input/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Text> Note: Once `Next` is selected you will not be able to close the model until the end.</Text>
                </Form>
            </Modal>

            <Modal
                {...initiateCorporateOnboardingModal}
                closable={false}
                maskClosable={false}
                keyboard={false}
                footer={[
                    <Button
                        key="back"
                        disabled={true}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        onClick={() => {
                            initiateCorporateOnboardingForm.form?.submit();
                        }}>
                        Next
                    </Button>,
                ]}
            >
                <Form
                    {...initiateCorporateOnboardingForm}
                    layout="vertical"
                    initialValues={{
                        companyId,
                        accountNameForValidation: brandName,
                    }}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="companyId"
                                label="Company Id"
                            >
                                <Input
                                    value={companyId}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="accountNameForValidation"
                                label="Brand Name"
                            >
                                <Input
                                    value={brandName}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                label="Entity Type"
                                name="entityTypeId"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please select a value",
                                    },
                                ]}
                            >
                                <Select
                                    options={[subMerchantEntityTypeOptions]}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                label="Business Type"
                                name="businessTypeId"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please select a value",
                                    },
                                ]}
                            >
                                <Select
                                    options={[subMerchantBusinessTypeOptions]}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </Space>
    );
};